module.exports = __webpack_public_path__ + "WealthCare Saver HSA Text Messaging Registration.pdf";